import React, { useState, useEffect, useMemo } from "react";

import ParagraphList from "./ParagraphList";
import ParagraphBox from "./ParagraphBox";
import CloseButton from "../../../../../components/CloseButton";

const ParagraphSelectionPage = ({
  worksheet,
  onClose,
  onClickNext,
  selectedTypes,
  selectedParagraphs,
  setSelectedParagraphs,
  isRetryEnabled,
  setIsRetryEnabled,
  isAutoRetryEnabled,
  setIsAutoRetryEnabled,
  maxRetries,
  setMaxRetries,
}) => {
  const worksheetData = useMemo(() => {
    if (worksheet.type === "comprehensive") {
      const examIndex =
        selectedTypes.find((type) => type.key === "comprehensive")?.index || 1;
      return worksheet.data[examIndex - 1];
    } else {
      return worksheet.data;
    }
  }, [worksheet.type, worksheet.data, selectedTypes]);

  const [activeParagraph, setActiveParagraph] = useState(worksheetData[0]);

  useEffect(() => {
    setSelectedParagraphs(worksheetData.map((_, i) => i));
  }, [setSelectedParagraphs, worksheetData]);

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        borderRadius: "10px",
        width: "1200px",
        height: "700px",
        display: "flex", // 좌우 레이아웃
      }}
    >
      {/* 오른쪽 상단 닫기 버튼 */}
      <CloseButton onClick={onClose} />

      {/* 왼쪽: Paragraph 목록 & 체크박스 */}
      <ParagraphList
        worksheetData={worksheetData}
        worksheetTitle={worksheet.title}
        activeParagraph={activeParagraph}
        setActiveParagraph={setActiveParagraph}
        selectedParagraphs={selectedParagraphs}
        setSelectedParagraphs={setSelectedParagraphs}
      />

      {/* 오른쪽: Paragraph 상세 내용 */}
      <div
        style={{
          flex: 1,
          padding: "10px",
          overflowY: "auto",
          position: "relative",
        }}
      >
        {activeParagraph ? (
          <ParagraphBox paragraph={activeParagraph} type={worksheet.type} />
        ) : (
          <p>왼쪽 목록에서 지문을 클릭해주세요.</p>
        )}
        {/* 복습 설정 UI */}
        {worksheet.type === "paragraph" && (
          <div
            style={{
              position: "absolute",
              bottom: "80px",
              left: "10px",
              right: "10px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
            }}
          >
            <h4 style={{ margin: "0 0 10px 0", fontSize: "16px" }}>복습 설정</h4>

            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "8px" }}>
              <label style={{ fontSize: "14px", display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={isRetryEnabled}
                  onChange={(e) => setIsRetryEnabled(e.target.checked)}
                  style={{ marginRight: "8px" }}
                />
                <span style={{ marginLeft: "8px" }}>복습 활성화</span>
              </label>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "8px" }}>
              <label style={{ fontSize: "14px", display: "flex", alignItems: "center", opacity: isRetryEnabled ? 1 : 0.5 }}>
                <input
                  type="checkbox"
                  checked={isAutoRetryEnabled}
                  onChange={(e) => setIsAutoRetryEnabled(e.target.checked)}
                  disabled={!isRetryEnabled}
                  style={{ marginRight: "8px" }}
                />
                <span style={{ marginLeft: "8px" }}>자동 복습 활성화</span>
              </label>
            </div>

            <div style={{ marginBottom: "8px" }}>
              <label style={{ fontSize: "14px", opacity: isRetryEnabled ? 1 : 0.5 }}>
                최대 복습 회수:<br />
                <select
                  value={isRetryEnabled ? maxRetries : 0}
                  onChange={(e) => setMaxRetries(Number(e.target.value))}
                  disabled={!isRetryEnabled}
                  style={{
                    marginTop: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                >
                  <option value={0}>비활성화</option>
                  <option value={1}>1회</option>
                  <option value={2}>2회</option>
                  <option value={3}>3회</option>
                  <option value={4}>4회</option>
                  <option value={5}>5회</option>
                  <option value={-1}>무제한</option>
                </select>
              </label>
            </div>
          </div>
        )}

        {/* 우측 하단: 체크박스 & 다음 버튼 */}
        <div
          style={{
            position: "absolute",
            padding: "10px",
            bottom: "10px",
            left: "10px",
            right: "10px",
            display: "flex",
            justifyContent: "right",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          {/* 다음 버튼 */}
          <button
            style={{
              padding: "5px 40px",
              backgroundColor: "#2D2D2D",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={onClickNext}
          >
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParagraphSelectionPage;
